import { connect } from 'react-redux'

import { login, loginSocialsError, loginUsingApple, loginUsingFacebook, loginUsingGoogle } from './reducer'

const mapStateToProps = (state) => {
    return {
        isAuth: state?.services?.auth?.isAuthorized,
        loading: state?.pages?.login?.loading,
        error: state?.pages?.login?.error,
        errorType: state?.pages?.login?.errorType,
    }
}

const hocConnect = (InnerComponent) =>
    connect(mapStateToProps, { login, loginUsingFacebook, loginUsingGoogle, loginSocialsError, loginUsingApple })(
        InnerComponent
    )

export default hocConnect
